import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../services/global.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { MLService } from '../services/ml-service';
import { AlertComponent } from '../common/alert/alert.component';
import { Globals } from '../models/globals.model';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { FilterFieldTypes } from '../common/common-constants';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ConfigureModelService } from '../services/configure-model-service';
import { ConfigureModelComponent } from '../configure-model/configure-model.component';

@Component({
  selector: 'app-configure-model-list',
  templateUrl: './configure-model-list.component.html',
  styleUrls: ['./configure-model-list.component.css']
})
export class ConfigureModelListComponent implements OnInit, OnDestroy {
  dataToPass: any = [];
  accessTokenModel: any;
  expandedIndex: any;
  stringLimit = 20;
  isLoading = true;
  modelErrorMessage = 'Error';
  isModelErrorApp = false;
  isModelErrorAPI = false;
  isModelErrorOps = false;
  isModelErrorService = false;
  selectedItem: string = 'All';
  configureModelListDetails: MatTableDataSource<any>;
  selection = new SelectionModel<any>(false, []);
  displayedColumns: string[] = ['registrationName', 'type', 'modelVersion', 'url', 'lastModifiedBy', 'action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  selModelToDelete: any;
  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;
  public destroyed = new Subject<any>();

  constructor(
    public router: Router,
    public globals: Globals,
    public globalService: GlobalService,
    public httpClientObj: HttpClient,
    public configureModelService: ConfigureModelService,
    public mlService: MLService,
    public dialog: MatDialog) {
    const emptyList: any[] = [];
    this.configureModelListDetails = new MatTableDataSource(emptyList);
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)).subscribe(() => { this.initialize(); });
  }

  ngOnInit() {
    // 'ngOnInit' should not be empty    
  }

  initialize() {
    this.mlService.geAuthCode().subscribe((data: any): void => {
      this.isLoading = true;
      this.accessTokenModel = data.accessToken;
      this.isModelErrorApp = false;
      this.getListofModel();
    }, (error: Error) => {
      console.log('Error while getting Bearer token, more details: ', error.message);
    });
  }

  getListofModel() {
    this.selectedFilters = [];
    this.configureModelService.GetConfigureModelList().subscribe((data: any): void => {
      if (data && data !== null && data.length > 0) {
        this.masterData = [...data];
        this.configureModelListDetails = new MatTableDataSource(data);
        this.configureModelListDetails.sort = this.sort;
        this.configureModelListDetails.paginator = this.paginator;
        this.isLoading = false;
      }
      else {
        this.configureModelListDetails.data = [];
      }
      this.isLoading = false;
      this.createFilterList();
    }, (error: Error) => {
      this.globalService.showAlert(AlertComponent, { success: false, message: "Error in fetching model repository" });
      this.isLoading = false;
    });
  }

  erroHandlingModSer(msg, error) {
    this.isModelErrorService = true;
    this.modelErrorMessage = msg + error;
  }

  removeErrorMessage() {
    this.isModelErrorApp = false;
    this.isModelErrorService = false;
    this.isModelErrorAPI = false;
    this.isModelErrorOps = false;
  }

  /**Triggered to check if Configure Model In Use */
  checkConfigureModel(clickEvent, clickedModel) {
    this.isLoading = true;
        this.configureModelService.checkConfigureModelInUse(clickedModel.modelConfigrationId).subscribe((data: any) => {
          if (data && clickEvent !== 'viewModel') {
            this.isLoading = false;
            this.globalService.showAlert(AlertComponent,
              { success: false, message: clickedModel.registrationName + " can not be updated or deleted." });
          }
          else {
            this.configureModelService.getConfigureModelDetailsById(clickedModel.modelConfigrationId).subscribe((configureModeldata: any) => {
              if (configureModeldata && clickEvent == 'editModel') {
                this.openDialog('editModel', configureModeldata)
              } else if (configureModeldata && clickEvent == 'viewModel') {
                this.openDialog('viewModel', configureModeldata)
              } else {
                this.deleteModel(configureModeldata)
              }
            });
          }
          this.isLoading = false;
        }, (err) => {
          console.log(err);
        });
  }

  deleteModel(selectedModel) {
    this.isLoading = true;
    this.selModelToDelete = selectedModel;
    let message = "";
    let dataToPass = {
      title: 'Delete',
      isDelete: true,
      message: message + ' Do you really want to delete this model?'
    };
    this.isLoading = false;
    this.globalService.openModelWindow(this.deleteOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
  }

  deleteOnConfirm(thisRef: ConfigureModelListComponent) {
    thisRef.isLoading = true;
    let modelConfigurationId = thisRef.selModelToDelete.modelConfigrationId;
    thisRef.configureModelService.deleteConfigureModel(modelConfigurationId).subscribe((data: any): void => {
      thisRef.globalService.showAlert(AlertComponent, { success: true, message: "Configure Model deleted successfully!" });
      thisRef.getListofModel();
    }, (error: Error) => {
      thisRef.erroHandlingModSer('Error in deleting model' + thisRef.selModelToDelete.modelName + '. More details: ', error.message);
      thisRef.isLoading = false;
    });
  }

  openDialog(ops, modelData?) {
    let dataToPass = {
      'selectedData': ops === 'editModel' || 'viewModel'  ? modelData : '',
      'accessToken': this.accessTokenModel,
      'modelsData': this.masterData,
      'modelAction' : ops
    };
    this.openModelWindow(ConfigureModelComponent, '100%', 'custom-modalbox', dataToPass);
  }

  openModelWindow(modelComponent, widthOfWindow, panleClassName, dataToPass) {
    const dialogRef = this.dialog.open(modelComponent, {
      width: widthOfWindow,
      panelClass: panleClassName,
      data: dataToPass
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        this.selection.clear();
        this.getListofModel();
      }
    });
  }

  /**
   * Filters data based on input text
   * @param filterValue
   */
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase(); // Remove whitespace and MatTableDataSource defaults to lowercase matches
    this.configureModelListDetails.filter = filterValue;
  }

  /**Creates data for filter list */
  createFilterList() {
    this.filterList = [];
    for (let a = 0; a < this.displayedColumns.length - 1; a++) {
      let tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldName = this.globalService.replaceDisplayText(this.displayedColumns[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      if (this.displayedColumns[a] == "registrationName") {
        unique = [...new Set(this.configureModelListDetails.data.map(a => a.registrationName))];
      } else if (this.displayedColumns[a] == "type") {
        unique = [...new Set(this.configureModelListDetails.data.map(a => a.type))];
      } else if (this.displayedColumns[a] == "modelVersion") {
        unique = [...new Set(this.configureModelListDetails.data.map(a => a.modelVersion))];
      } else if (this.displayedColumns[a] == "url") {
        unique = [...new Set(this.configureModelListDetails.data.map(a => a.url))];
      } else if (this.displayedColumns[a] == "lastModifiedBy") {
        unique = [...new Set(this.configureModelListDetails.data.map(a => a.lastModifiedBy))];
      }
      tempFilter.values = unique.filter(n => n);
      this.filterList.push(tempFilter);
    }
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.configureModelListDetails.data = this.globalService.conditionalDataFiltering(filterResponse, this.configureModelListDetails.data);
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.configureModelListDetails.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.configureModelListDetails.data = this.globalService.conditionalDataFiltering(element, this.configureModelListDetails.data);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

}

